import { Link } from 'react-router-dom'

interface IntakeDoneCardProps {
  savedCount: number
}

export function IntakeDoneCard({ savedCount }: IntakeDoneCardProps) {
  return (
    <section className="space-y-4 rounded-xl border border-border bg-background p-6 text-center">
      <div className="space-y-1">
        <h2 className="text-lg font-bold tracking-tight">
          {savedCount > 0
            ? `${savedCount} ${savedCount === 1 ? 'story' : 'stories'} in your bank`
            : 'Nothing saved this time'}
        </h2>
        <p className="text-sm text-muted-foreground">
          {savedCount > 0
            ? 'Open them any time before an interview — and practice answering with them in mind.'
            : 'No problem — start another conversation whenever you think of something.'}
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        <Link
          to="/story-bank"
          className="rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          Open my Story Bank
        </Link>
        <Link
          to="/interview/setup"
          className="rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-muted"
        >
          Practice an interview
        </Link>
      </div>
    </section>
  )
}
